import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { LimiteAgenteFinanceiro } from 'src/app/model/limite-agente-financeiro.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TrancheService } from 'src/app/shared/services/tranche.service';

import moment from "moment";
import { Tranche } from 'src/app/model/tranche.model';
import { ExportService } from 'src/app/shared/services/export.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-limite-listagem',
    templateUrl: './limite-listagem.component.html',
    styleUrls: ['./limite-listagem.component.scss'],
    standalone: false
})
export class LimiteListagemComponent implements OnInit, OnChanges {

  @Input() agenteFinanceiro: AgenteFinanceiro;
  @Input() refresh: any;
  @Input() permiteEdicao: boolean = false;
  @Input() permiteDetalhe: boolean = false;
  @Input() existeLimiteAgenteFinanceiroTranche: boolean = true;
  @Input() tranche: Tranche;
  @Input() ehFGBS: boolean;
  @Input() idLimiteAdicional: number;

  public limites: LimiteAgenteFinanceiro[];
  public dataLimites: string = undefined;
  public trancheAtiva: boolean;

  constructor(
  private agenteFinanceiroService: AgenteFinanceiroService,
  private loadingService: BnLoadingService,
  private trancheService: TrancheService,
  private exportService: ExportService,
  private router: Router,
) { }

  ngOnInit() {
   
  }

  ngOnChanges(changesObj) {
    if (changesObj.refresh) {
      console.log('dentro do onchange listabem', this.idLimiteAdicional);
      
      this.buscaLimiteAgenteFinanceiro();
    }
  }

  get limiteEspecialAtivo() {
    if (!this.limites) {
      return false;
    }

    if (!this.limites.length) {
      return false;
    }

    for (let limite of this.limites) {
      if (limite.valorLimiteEspecial) {
        return true;
      }
    }

    return false;
  }

  private buscaLimiteAgenteFinanceiro() {

    if (this.agenteFinanceiro && this.tranche) {

      this.trancheService.getTrancheAtual().subscribe((trancheAtual) => {
        if (trancheAtual.id == this.tranche.id) {
          this.trancheAtiva = true;
        }
      });

      if (this.agenteFinanceiro.id == -1) {

        this.loadingService.bloqueiaTela();

        const obs = this.idLimiteAdicional
          ? this.agenteFinanceiroService.buscaLimitesAdicionaisFg2(
              this.tranche.id,
              this.idLimiteAdicional)
          : this.agenteFinanceiroService.buscaLimitesFg2(
              this.tranche.id);

        obs.subscribe((resp) => {

          this.limites = resp.sort(
            (a, b) =>
              a.agenteFinanceiro.nome.localeCompare(
                b.agenteFinanceiro.nome)
          );

          this.limites.forEach(lim => {
            if (lim.valorLimite.valorLimiteDisponivel < 0) {
              lim.valorLimite.valorLimiteDisponivel = 0;
            }
          });

          this.dataLimites = moment().format('YYYY-MM-DD HH:mm:ss');

          this.loadingService.liberaTela();
        });

      } else {

        this.loadingService.bloqueiaTela();

        const obs = this.idLimiteAdicional
          ? this.agenteFinanceiroService.buscaLimiteAdicionalFg2(
              this.agenteFinanceiro.cnpj,
              this.tranche.id,
              this.idLimiteAdicional)
          : this.agenteFinanceiroService.buscaLimiteFg2(
              this.agenteFinanceiro.cnpj,
              this.tranche.id);

        obs.subscribe((resp) => {

          this.limites = [resp];

          this.dataLimites = moment().format('YYYY-MM-DD HH:mm:ss');

          this.loadingService.liberaTela();
        });
      }

    } else {

      this.limites = undefined;
      this.dataLimites = undefined;
    }
  }

  
  public editarLimite(limite: LimiteAgenteFinanceiro) {
      if (this.idLimiteAdicional) {
        this.router.navigate(['/limite-adicional/limite-af/edicao/' + this.tranche.id], {
          state: {
            origem: 'limite/pesquisa',
            idAgenteFinanceiro: limite.agenteFinanceiro.id,
            idLimiteAdicional: this.idLimiteAdicional,
          }
        });
      } else {
        this.router.navigate(['/limite/cadastro', limite.id]);
      }
    }
    
    public visualizarLimite(limite: LimiteAgenteFinanceiro) {

      if (this.idLimiteAdicional) {

        this.router.navigate(
          ['/limite/detalhe/' + limite.id],
          {
            state: {
              idLimiteAdicional: this.idLimiteAdicional,
              cnpjAgente: limite.agenteFinanceiro.cnpj,
              ideTranche: this.tranche.id,
            }
          }
        );

      } else {

        this.router.navigate(
          ['/limite/detalhe', limite.id]
        );

      }
    }

  getDestaqueLimite(limite): string {
    let cssClass:string = '';

    if (this.limiteEspecialAtivo && limite.valorLimiteEspecial?.valorLimiteTotal > 0.00) {
      cssClass += ' fundo-destaque';
    }

    if (limite.valorLimite.valorLimiteDisponivel < 0.00) {
      cssClass += ' texto-destaque';
    }

    return cssClass.trim();
  }

  btnExportarLimites() { 
    this.loadingService.bloqueiaTela();
    if (this.limites) {
      this.exportService.exportarListaLimites(this.limites, this.existeLimiteAgenteFinanceiroTranche, this.ehFGBS);
    }
  }
  
}
